<template>
  <div class="page-eventInfo">
    <Table :columns="columns" :data="dataSource" :loading="loading"></Table>
    <div style="margin-top: 16px; text-align: right">
      <Page
        :total="total"
        :current="page"
        :page-size="size"
        :page-size-opts="sizes"
        :show-total="true"
        :show-elevator="true"
        :show-sizer="true"
        @on-change="onCurrentChange"
        @on-page-size-change="onSizeChange"
      />
    </div>
  </div>
</template>
<script>
import { getUserLogApi } from "../../../api/user";
const action = {
  create: "新建",
  add: "新增",
  list: "查询",
  update: "更新",
  delete: "删除"
};
export default {
  props: {
    info: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      columns: [
        {
          title: "活动类型",
          align: "center",
          key: "remark",
        },
        {
          title: "操作类型",
          align: "center",
          key: "action",
          render: (h, props) => {
            return h("span", action[props.row.action]);
          }
        },
        {
          title: "操作内容",
          align: "center",
          key: "content",
        },
        {
          title: "操作人",
          key: "name",
          align: "center",
        },
        {
          title: "操作时间",
          align: "center",
          key: "create_time",
        },
      ],
      dataSource: [],
      total: 0,
      page: 1,
      size: 10,
      sizes: [10, 20, 30, 40, 50],
      loading: false
    }
  },
  methods: {
    onCurrentChange(current) {
      this.page = current;
      this.getUserLog();
    },
    onSizeChange(size) {
      this.size = size;
      this.getUserLog();
    },
    getUserLog() {
      const { page, size } = this;
      const { user_id } = this.info
      getUserLogApi({
        customer_id: user_id,
        target_types: "user,follow,patient,template,apply",
        page, size
      }).then(res => {
        if (res.code === 0) {
          this.dataSource = res.data;
          this.total = res["x-total-count"];
          if(this.total && !this.dataSource.length && this.page > 1) {
            this.page = this.page - 1;
            this.getUserLog();
          }
        }
      })
    }
  }
}
</script>
<style lang="less">
.page-eventInfo{
  padding: 16px;
}
</style>